import React from 'react';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { STATUS_FILTERS } from './PayBits';

const half = 'w-[calc(50%-0.25rem)] sm:w-40 h-9';

// Shared filters: league/tournament, date range, official, role, payment status.
export const PayFilters = ({ f, setF, competitions, officials, roles, showStatus = true, showRole = true, showOfficial = true, showLeague = true, officialLabel = 'All officials' }) => {
  const set = (k, v) => setF(p => ({ ...p, [k]: v === 'all' ? '' : v }));
  return (
    <div className="flex flex-wrap items-center gap-2 bg-white border rounded-xl p-2.5" data-testid="pay-filters">
      {showLeague && (
        <Select value={f.event_id || 'all'} onValueChange={v => set('event_id', v)}>
          <SelectTrigger className="w-full sm:w-48 h-9" data-testid="pay-filter-league"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="all">All leagues & tournaments</SelectItem>{competitions.map(c => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}</SelectContent>
        </Select>
      )}
      <Input type="date" value={f.from_date || ''} onChange={e => set('from_date', e.target.value)} className={half} data-testid="pay-filter-from" />
      <Input type="date" value={f.to_date || ''} onChange={e => set('to_date', e.target.value)} className={half} data-testid="pay-filter-to" />
      {showOfficial && (
        <Select value={f.official_id || 'all'} onValueChange={v => set('official_id', v)}>
          <SelectTrigger className={half} data-testid="pay-filter-official"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="all">{officialLabel}</SelectItem>{officials.map(o => <SelectItem key={o.id} value={o.id}>{o.full_name}</SelectItem>)}</SelectContent>
        </Select>
      )}
      {showRole && (
        <Select value={f.role_key || 'all'} onValueChange={v => set('role_key', v)}>
          <SelectTrigger className={half} data-testid="pay-filter-role"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="all">All roles</SelectItem>{roles.map(r => <SelectItem key={r.key} value={r.key}>{r.label}</SelectItem>)}</SelectContent>
        </Select>
      )}
      {showStatus && (
        <Select value={f.status || 'all'} onValueChange={v => set('status', v)}>
          <SelectTrigger className={half} data-testid="pay-filter-status"><SelectValue /></SelectTrigger>
          <SelectContent>{STATUS_FILTERS.map(([k, l]) => <SelectItem key={k || 'all'} value={k || 'all'}>{l}</SelectItem>)}</SelectContent>
        </Select>
      )}
      {Object.values(f).some(Boolean) && (
        <button type="button" onClick={() => setF({})} className="text-xs font-semibold text-slate-500 hover:text-slate-800 px-1" data-testid="pay-filter-clear">Clear</button>
      )}
    </div>
  );
};
